'use strict';

import React from 'react'

import { v4 as uniqid } from 'uuid'
import _      from 'lodash'

import Layout from '@Layout/ECFront'

import HolidaysMessage from '@/HolidaysMessage'

import getErrorsFromResponse from '@/Form/Functions/getErrorsFromResponse'
import getFormStatus         from '@/Form/Functions/getFormStatus'

import DataList from '@/DataList'

import config from '@Config/EC/EC_member'

import bemit from '@function/bemit'

import Loader from '@Pure/Loader'

const data_config = _.cloneDeep(config);

const { app, moment, qwest } = window;

export default class ECUsersPage extends React.Component
{
	constructor (props)
	{
		super(props);

		const inner_component = this;

		this.state =
		{
			data: [],
			references: [],
			session_id: uniqid()
		};

		data_config.title = 'Liste des membres';

		data_config.header_map =
		{
			'E-mail (login)': 'login',
			'Nom': 'lastname',
			'Prénom': 'firstname',
			'Activé le': 'validation_date',
			'Date de création': 'createdAt',
			'Ville': 'address.city',
			'Statut': 'validation_status',
			'Réf. interne': 'internal_ref',
			'Date de fin': 'disabled_date',
		};

		data_config.searched_prop =
		[
			'login', 'firstname', 'lastname', 'internal_ref'
		];

		data_config.sortable_cols =
		[
			'login', 'lastname', 'validation_status', 'internal_ref'
		];

		data_config.date_fields = [];

		data_config.field_hook = data_config.field_hook || { };

		data_config.field_hook['Prénom'] = function (value)
		{
			return (value || '').toUpperCase();
		};

		data_config.field_hook['Nom'] = function (value)
		{
			return (value || '').toUpperCase();
		};

		data_config.field_hook['Activé le'] = function (value)
		{
			return value
			? moment(value).format('DD/MM/YYYY')
			: '';
		};

		data_config.field_hook['Date de création'] = function (value)
		{
			return value
			? moment(value).format('DD/MM/YYYY')
			: '';
		};

		data_config.field_hook['Statut'] = function (value, element, cmp_ref)
		{
			inner_component.fetchData = cmp_ref.fetchData;

			if (value === 'validated')
			{
				let output =
				(
					<div className={ bemit('c-status-indicator', ['green']) +
						' u-full-width' } onClick={ onClick }>
						<div className="c-status-indicator__circle"></div>
						Activé
					</div>
				);

				return output;
			}
			else if (value === 'disabled')
			{
				let output =
				(
					<div className={ bemit('c-status-indicator') +
						' u-full-width' } onClick={ onClick }>
						<div className="c-status-indicator__circle"></div>
						Désactivé
					</div>
				);

				return output;
			}
			else if (value === 'pending')
			{
				let output =
				(
					<div className={ bemit('c-status-indicator', ['red']) +
						' u-full-width' } onClick={ onClick }>
						<div className="c-status-indicator__circle"></div>
						En attente
					</div>
				);

				return output;
			}
			else
			{
				let output =
				(
					<div className={ bemit('c-status-indicator', ['blue']) +
						' u-full-width' } onClick={ onClick }>
						<div className="c-status-indicator__circle"></div>
						Récupéré
					</div>
				);

				return output;
			}

			function onClick (e)
			{
				app.emit('open__ValidateUserModal', element);
			}
		};

		data_config.field_hook['Réf. interne'] = function (value, element, cmp_ref)
		{
			let output =
			(
				<div className="u-full-width u-cursor" onClick={ onClick }>
					{ value || '-' }
				</div>
			);

			return output;

			function onClick (e)
			{
				app.emit('open__UserRefModal', element);
			}
		};

		data_config.field_hook['Date de fin'] = function (value, element, cmp_ref)
		{
			let output =
			(
				<div className="u-full-width u-cursor" onClick={ onClick }>
					{ value || '-' }
				</div>
			);

			return output;

			function onClick (e)
			{
				app.emit('open__UserDisabledDateModal', element);
			}
		};

		delete data_config.row_link_base;
		delete data_config.creation_label;
		delete data_config.filter_query;
		delete data_config.link;
	}

	UNSAFE_componentWillMount ()
	{
		const component = this, props = this.props;

		app.resetFunctions();

		app.push(
		{
			event: 'sessionChange',
			cb: component.handleSessionChange
		});

		app.push(
		{
			event: 'validatedUser',
			cb: component.requestUpdate
		});

		app.push(
		{
			event: 'deletedUser',
			cb: component.requestUpdate
		});

		app.push(
		{
			event: 'changedUserRef',
			cb: component.requestUpdate
		});

		app.push(
		{
			event: 'changedUserDisabledDate',
			cb: component.requestUpdate
		});

		component.handleSessionChange();
	}

	componentWillUnmount ()
	{
		const component = this, props = this.props;

		app.delete(
		{
			event: 'sessionChange',
			cb: component.handleSessionChange
		});

		app.delete(
		{
			event: 'validatedUser',
			cb: component.requestUpdate
		});

		app.delete(
		{
			event: 'deletedUser',
			cb: component.requestUpdate
		});

		app.delete(
		{
			event: 'changedUserRef',
			cb: component.requestUpdate
		});

		app.delete(
		{
			event: 'changedUserDisabledDate',
			cb: component.requestUpdate
		});
	}

	requestUpdate = () =>
	{
		const component = this, props = this.props, state = this.state;

		component.updateList();
	}

	handleSessionChange = () =>
	{
		const component = this, props = this.props, state = this.state;

		if (!app.state.session.EC || !app.state.session.EC.id) return;

		if (app.state.session.EC.id === state.EC) return;

		data_config.filter_query =
		{
			'permissions.title': 'Membre de CE',
			EC: app.state.session.EC.id,
			sort: 'login ASC'
		};

		component.setState(
		{
			EC: app.state.session.EC.id,
			session_id: uniqid()
		});
	}

	updateList ()
	{
		const inner_component = this, props = this.props;

		if (inner_component.fetchData) inner_component.fetchData({ });
	}

	update_hook = (component) =>
	{
		this.updateList = this.updateList.bind(component);
	}

	requestDisableMembers = (e) =>
	{
		const component = this, props = this.props, state = this.state;

		component.setState({ ask_confirmation: true });
	}

	cancelDisabling = (e) =>
	{
		const component = this, props = this.props, state = this.state;

		component.setState({ ask_confirmation: false, confirmation: false });
	}

	disableMembers = (e) =>
	{
		const component = this, props = this.props, state = this.state;

		component.setState(
		{
			loading: true,

			info: undefined,
			error: undefined,
			warning: undefined
		});

		qwest.post('/EC/disable-members').then(function (xhr, response)
		{
			component.setState(
			{
				info: 'Membres désactivés.',
				loading: false,
				ask_confirmation: false
			});

			component.updateList();

			window.setTimeout(function ()
			{
				component.setState({ info: undefined });
			},
			1500);
		})
		.catch(function (error, xhr, response)
		{
			console.error(response?.error || response?.raw || error);

			component.setState(
			{
				...getErrorsFromResponse(
				{
					response: response
				})
			});
		});
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		let disabling_section;

		if (!state.ask_confirmation)
		{
			disabling_section =
			(
				<button type="button" className={ bemit('c-btn', ['red']) }
					onClick={ component.requestDisableMembers }>
					Désactiver tous les membres
				</button>
			);
		}
		else
		{
			const disable_btn =
			(
				<button className="c-message__clickable"
					onClick={ component.disableMembers }>
					Oui, désactiver
				</button>
			);

			const cancel_btn =
			(
				<button className="c-message__clickable u-margin-left-10"
					onClick={ component.cancelDisabling }>
					Non, annuler
				</button>
			);

			disabling_section =
			(
				<div className={ bemit('c-message', ['blue']) }>

					<div className="c-message__content">
						Êtes-vous certain(e) de vouloir désactiver tous les membres &nbsp;? { disable_btn } - { cancel_btn }
					</div>

				</div>
			);
		}

		const loader = state.loading === true ?
		(
			<Loader className="c-loader" bemit={ ['primary', 'bg-white'] } />
		)
		: undefined;

		var output =
		(
			<Layout page_title="Utilisateurs" history={ props.history }>

				<div className="page-content">

					<HolidaysMessage />

					<div className="o-content">

						{
							state.EC ?
							(
								<a href="/export/liste-des-membres" target="_blank"
									className="c-btn u-margin-bottom-15">
									Télécharger la liste complète
								</a>
							)
							: undefined
						}

						{
							state.EC ?
							(
								<DataList history={ props.history }
									fetch={ true }
									config={ data_config }
									references={ component.state.references }
									onMount={ component.update_hook }
									default_sort_order="ASC"
									default_sort_field="validation_status"
									key={ state.key }
								/>
							)
							: undefined
						}

						{ getFormStatus(state) }

						<div className="u-full-width u-text-right u-margin-top-30
							u-positioned">

							{ disabling_section }

							{ loader }

						</div>

					</div>

				</div>

			</Layout>
		);

		return output;
	}
}